/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    call,
    fork,
    put,
    select,
    takeEvery,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import { checkJWT } from '../../../../Member/ducks/Auth/Auth-Operations';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';
import { getChatgptGiftMessage, updateChatgptGiftMessage } from './ChatGptMessage-Actions';
import { getChatGptMessageData } from './ChatGptMessage-Selectors';
import { getRelationshipListById } from '../../App/App-Selectors';

function* workerGetChatgptMessage(action) {
    try {
        const jwtToken = yield call(checkJWT);
        const { cartItemId, chatGptData } = action.data || {};
        const relationshipList = yield select(getRelationshipListById);

        const {
            occasion, relation, recipientName, tone,
            characterLimit, userId, anyStepHasChanged,
        } = chatGptData || {};

        const getChatgptMessageResponse = yield call(cartServiceClient.getChatgptMessage, {
            env: {},
            jwtToken,
            payload: {
                occasion,
                relation: relation ? relationshipList[relation] : '',
                recipientName,
                tone,
                characterLimit,
                userId,
            },
        });

        const currentChatGPTData = yield select(getChatGptMessageData);
        const newChatGPTData = {
            recipientName: chatGptData.recipientName,
            relation: chatGptData.relation,
            occasion: chatGptData.occasion,
            tone: chatGptData.tone,
            selectedPosition: 0,
            giftMessage: [],
        };

        // get the message is currently in the redux saga
        if (currentChatGPTData?.[cartItemId]?.giftMessage && !anyStepHasChanged) {
            newChatGPTData.giftMessage = currentChatGPTData[cartItemId].giftMessage;
        }

        if (getChatgptMessageResponse?.data?.isSuccessful === true) {
            if (newChatGPTData.giftMessage?.length < 5) {
                // add the new message if the limit is not researched
                newChatGPTData.giftMessage.push(getChatgptMessageResponse.data.giftMessage);
            }
            newChatGPTData.selectedPosition = newChatGPTData.giftMessage?.length > 0 ? (newChatGPTData.giftMessage.length - 1) : 0;
            yield put(updateChatgptGiftMessage(cartItemId, newChatGPTData));
            if (action.data?.handleCallBack) {
                yield call(action.data.handleCallBack, newChatGPTData.giftMessage, newChatGPTData.selectedPosition);
            }
        } else if (getChatgptMessageResponse?.data?.isSuccessful === false) {
            const errorMessage = getChatgptMessageResponse?.data?.reason || 'Something unexpected occurred while we were trying get the message, please try again.';
            yield put(updateChatgptGiftMessage(cartItemId, newChatGPTData));
            yield call(action.data.handleCallBack, newChatGPTData.giftMessage, 0, errorMessage);
            console.error('Chat GPT error:', errorMessage);
        }
    } catch (error) {
        console.error('Chat GPT exception:', error);
        const { cartItemId, chatGptData } = action.data || {};
        const newChatGPTData = {
            recipientName: chatGptData.recipientName,
            relation: chatGptData.relation,
            occasion: chatGptData.occasion,
            tone: chatGptData.tone,
            selectedPosition: 0,
            giftMessage: [],
        };

        yield put(updateChatgptGiftMessage(cartItemId, newChatGPTData));

        mbpLogger.logError({
            data: action.data,
            appName: process.env.npm_package_name,
            module: 'ChatGptMessage-Operations.js',
            function: 'workerGetChatgptMessage',
            jsError: error,
            message: 'Failed finding chat gpt suggested message',
        });

        yield put(updateChatgptGiftMessage(action.data.cartItemId, {}));
        yield call(action.data.handleCallBack, [], 0, error?.response?.data?.message || 'Error getting Chat GPT message');
    }
}

function* watcherGetChatgptMessage() {
    yield takeEvery(getChatgptGiftMessage().type, workerGetChatgptMessage);
}

const watchers = [
    fork(watcherGetChatgptMessage),
];

export { watchers };

export default {};
